import * as React from "react";
const CheckIcon = ({color, ...rest}) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...rest}
	>
		<path
			d="M6 12L10.2426 16.2426L18.727 7.75732"
			stroke={color ? color : 'white'}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default CheckIcon;
